import { useEffect, useState } from "react";
import { getUserGroupById } from "../services/groupService";

interface IUseFetchGroupById {
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  groupId: string | null;
}

const useFetchGroupById = ({ setIsLoading, groupId }: IUseFetchGroupById) => {
  const [groupData, setGroupData] = useState<any>(null);

  useEffect(() => {
    if (!groupId) {
      setGroupData(null);
      return;
    }

    setIsLoading(true);
    const getGroupData = async () => {
      try {
        const res = await getUserGroupById(groupId);
        setGroupData(res);
      } catch (err) {
        setGroupData(null);
      } finally {
        setIsLoading(false);
      }
    };
    getGroupData();
  }, [setIsLoading, groupId]);

  return [groupData];
};

export default useFetchGroupById;
